// Single source for app-level constants shown in the UI (About, Menu footer).
// Keep in sync with package.json and the native versionName on release.
export const APP_VERSION = '1.15.1'

// Contact address for support / privacy questions.
export const CONTACT_EMAIL = 'info@codesuma.dev'

// Static JSON of Hijri moon-sighting corrections, polled at startup so an
// urgent fix reaches users without an app release (services/hijri-adjustments).
// Absolute on purpose: the native builds serve the bundle from https://localhost,
// where a relative path would resolve inside the app. Set to '' to disable the
// check entirely — the built-in list then stands alone.
export const HIJRI_ENDPOINT = 'https://emrouz.app/hijri.json'

// The country holiday catalog, read the same way and for the same reason: a
// country published here reaches installed apps without a release
// (services/catalog-source). Absolute for the same reason as the line above —
// the native builds serve the bundle from https://localhost, where a relative
// path would resolve inside the app. Set to '' to stand on the copy shipped
// inside the bundle alone.
export const CATALOG_ENDPOINT = 'https://emrouz.app/data/occasions'

// The market prices for the ticker over the calendar and the prices page
// (services/rates), from the prices API in api/. Absolute for the same reason
// as the lines above. The prices behind it change at most every half hour.
export const RATES_ENDPOINT = 'https://api.emrouz.app/rates'
